import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col gap-6"
}
const _hoisted_2 = {
  "data-voice-line": "",
  class: "flex items-center gap-3 rounded-lg border border-gray-300 px-3.5 py-3"
}
const _hoisted_3 = { class: "min-w-0 flex-1 text-sm text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-[13px] text-gray-600"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "rounded-lg border border-gray-300" }
const _hoisted_7 = { class: "pt-0.5 text-[#10b981]" }
const _hoisted_8 = { class: "min-w-0 flex-1" }
const _hoisted_9 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_10 = { class: "text-[13px] text-gray-600" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "rounded-lg border border-gray-200 bg-[#f9fafb]" }
const _hoisted_14 = {
  key: 2,
  "data-errors": "",
  role: "alert",
  class: "m-0 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700"
}

import { computed, ref } from 'vue'

import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { setupRows, skippedRows, voiceLine } from '@/helpers/agentWizardSummary'
import AgentTestPanel from '@/view/ai/agentWizard/AgentTestPanel.vue'

const CHANGE_CLASS = 'flex-shrink-0 text-[13px] text-gray-600 underline hover:text-gray-900'
const TESTING_NOTE = 'Everything is created in testing. Nothing texts a customer until you press Go live.'


export default {
  __name: 'AgentStepReview',
  setup(__props, { expose: __expose }) {

const wizard = injectWizard()

const voice = computed(() => {
  const line = voiceLine(wizard.data)
  return line.charAt(0).toUpperCase() + line.slice(1)
})
const brandSentence = computed(() => (wizard.data.voice.brand_voice_summary || '').trim())
const rows = computed(() => setupRows(wizard.data, wizard.stores.value, wizard.existing.value))
const skipped = computed(() => skippedRows(wizard.data, wizard.stores.value, wizard.existing.value))

// The shell footer's "Go live with all" runs through the test panel.
const panel = ref(null)
const goLiveAll = () => panel.value?.goLiveAll() ?? Promise.resolve(false)

__expose({ goLiveAll })

return (_ctx, _cache) => {
  return (_unref(wizard).created.value)
    ? (_openBlock(), _createBlock(AgentTestPanel, {
        key: 0,
        ref_key: "panel",
        ref: panel
      }, null, 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", null, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "m-0 mb-2 text-base font-bold text-gray-800" }, "Your voice", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(voice.value), 1),
              (brandSentence.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(brandSentence.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(CHANGE_CLASS),
              onClick: _cache[0] || (_cache[0] = $event => (_unref(wizard).go('voice')))
            }, "Change")
          ])
        ]),
        (rows.value.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "m-0 mb-2 text-base font-bold text-gray-800" }, "What we'll set up", -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row.key,
                    "data-setup-row": "",
                    class: _normalizeClass(["flex items-start gap-3 px-3.5 py-3", i ? 'border-t border-[#f3f4f6]' : ''])
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(WizardIcon, { name: "check" })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(row.label), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(row.detail), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(CHANGE_CLASS),
                      onClick: $event => (_unref(wizard).go(row.stepKey, row.storeId))
                    }, "Change", 8, _hoisted_11)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (skipped.value.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "m-0 mb-2 text-base font-bold text-gray-800" }, "Skipped", -1)),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skipped.value, (row, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row.key,
                    "data-skipped-row": "",
                    class: _normalizeClass(["flex items-center justify-between gap-3 px-3.5 py-2.5 text-sm text-gray-500", i ? 'border-t border-gray-200' : ''])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(row.label), 1),
                    _createElementVNode("span", null, _toDisplayString(row.reason), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", { class: "m-0 rounded-md bg-gray-100 px-3.5 py-3 text-sm text-gray-600" }, _toDisplayString(TESTING_NOTE)),
        (_unref(wizard).errors.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wizard).errors.value, (error) => {
                return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

}